module.exports = __webpack_public_path__ + "static/media/situations.042436ac.png";